import { Injectable } from '@angular/core';
import { ISessionEntry } from '../timing-tower/IRaceTiming';

@Injectable({
	providedIn: 'root',
})
export class FavoriteDriverService {
	// favoriteDrivers is a set containing hashes derived from car number and driver full name
	private favoriteDrivers = new Set();

	constructor() {
		this.readSessionStorage();
	}

	public addFavoriteDriver(driver: ISessionEntry) {
		const hash = this.driverHash(driver);
		this.favoriteDrivers.add(hash);
		this.updateSessionStorage();
	}

	public removeFavoriteDriver(driver: ISessionEntry) {
		const hash = this.driverHash(driver);
		this.favoriteDrivers.delete(hash);
		this.updateSessionStorage();
	}

	public isFavoriteDriver(driver: ISessionEntry) {
		const hash = this.driverHash(driver);
		return this.favoriteDrivers.has(hash);
	}

	private updateSessionStorage() {
		sessionStorage.setItem('favoriteDrivers', JSON.stringify([...this.favoriteDrivers]));
	}

	private readSessionStorage() {
		const storedData = sessionStorage.getItem('favoriteDrivers');
		if (!storedData) {
			return;
		}

		this.favoriteDrivers = new Set(JSON.parse(storedData));
	}

	private driverHash(driver: ISessionEntry): number {
		return this.simpleHash(driver.currentDriverFullName) * this.simpleHash(driver.number);
	}

	private simpleHash(str: string): number {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			// Standard bitwise operation to generate a numeric hash
			hash = (hash << 5) - hash + str.charCodeAt(i);
			hash |= 0; // Convert to 32-bit integer
		}
		return Math.abs(hash);
	}
}
